export default {
	name: 'Taction Panel Designer',
	version: '1.2',
	lastChangeDate: '2018-04-30',
	supportedImportExts: ['png', 'ttf'],
	supportedLayoutVersion: 4,
	maximumExportFileNameLength: 64,
	maximumImportFileSize: 20 * 1024 * 1024, // 50MB
	maximumAssetSize: 1024 * 1024 // 1MB
};



// WEBPACK FOOTER //
// ./src/config.js